import React, {useState, useCallback} from 'react'
import {generateId} from '@utils'
import Uploader from '../lib/uploader'
import * as api from '@api'
import useToast from '@/hooks/useToast'
import ErrorToast from '@/components/ErrorToast'

export default function useUploadFile() {
  const {toast} = useToast()
  const [processedFiles, setProcessedFiles] = useState([])
  const [processingFiles, setProcessingFiles] = useState([])
  const [fileResponseData, setFileResponseData] = useState(null)
  const [acceptedFiles, setAcceptedFiles] = useState([])
  const [error, setError] = useState(null)
  const [progress, setProgress] = useState()

  const clearProcessedFiles = useCallback(() => {
    setProcessedFiles([])
  }, [])

  const clearProgress = useCallback(() => {
    setProgress(undefined)
  }, [])

  const handleUpload = acceptedFiles => {
    const acceptedFilesWithId = acceptedFiles.map(f => ({
      file: f,
      uploadFileId: generateId(),
    }))
    const newProcessedFiles = []
    const newProcessingFiles = []

    for (const af of acceptedFilesWithId) {
      api.backend
        .uploadURLPost({filename: af.file.name, fileType: af.file.type, fileSize: af.file.size})
        .then(res => {
          if (res.error) {
            toast.custom(t => <ErrorToast t={t} error={res.error} />)
            return
          }

          setFileResponseData({
            ...res.data?.data,
          })
          const uploader = new Uploader({
            file: af.file,
            url: res.data?.data?.url,
            onComplete: r => {
              const fileData = {
                ...res.data?.data,
                progress: 100,
                uploadFileId: af.uploadFileId,
                size: af.file.size,
                name: af.file.name,
                type: af.file.type,
              }
              newProcessedFiles.push(fileData)
              if (newProcessedFiles.length === acceptedFiles.length) {
                setProcessedFiles([...processedFiles, ...newProcessedFiles])
              }
            },
            onError: e => {
              setError(true)
            },
            onProgress: e => {
              setProgress({
                e,
                fileResponseData: {
                  ...res.data?.data,
                },
                processingFiles: newProcessingFiles
              })
            },
          })

          const processingFileData = {
            ...res.data?.data,
            progress: 0,
            uploadFileId: af.uploadFileId
          }
          newProcessingFiles.push(processingFileData)
          setProcessingFiles([...newProcessingFiles])
          uploader.sendFile()
        })
    }
  }

  return {
    handleUpload,
    clearProcessedFiles,
    clearProgress,
    processedFiles,
    processingFiles,
    error,
    progress,
    fileResponseData,
    setProcessedFiles,
    setAcceptedFiles,
    acceptedFiles
  }
}
